import { Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import DefaultCollectionImg from '../../../assets/images/collection.png';
import Image from '../../../components/Image';

const { Text, Paragraph } = Typography;
function CollectionCard({
  collectionMd,
  collectionLg,
  title,
  description,
  collectionList,
  videoCount,
  blurHash,
  coverImg,
  href = '#'
}) {
  return (
    <div
      className={`collectioncard ${collectionMd ? 'collectionmd' : null} ${
        collectionLg ? 'collectionLg' : false
      } ${collectionList ? 'collectionList' : false}`}
    >
      <Link to={href} className="Collection-img relative">
        <Image
          blurHash={blurHash}
          src={coverImg || DefaultCollectionImg}
          alt={title}
        />
      </Link>
      <div className="collection-dec ">
        {title ? <Text className=" mb-4 block title">{title}</Text> : null}
        {videoCount !== undefined ? (
          <Text className="text-tiny-kicker text-n-800 mb-4 block video-count">
            {videoCount} Videos
          </Text>
        ) : null}

        {collectionList ? (
          <Paragraph className="text-small collectiondec">
            {description}
          </Paragraph>
        ) : (
          <Text className="text-tiny text-n-800  block collectiondec">
            {description}
          </Text>
        )}
      </div>
    </div>
  );
}
export default CollectionCard;
